import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-radio-tile-group',
    templateUrl: './wdx-radio-tile-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'input-radio-tiles',
    },
    standalone: false,
})
export class WdxRadioTileGroupComponent {}
